<template>
  <div class="custom-bread-crumb" ref="scrollOuter">
    <div class="btn-con left-btn">
      <Button type="text" @click="handleScroll(240)">
        <Icon :size="18" color="#CCC" type="ios-arrow-back" />
      </Button>
    </div>
    <div class="btn-con right-btn">
      <Button type="text" @click="handleScroll(-240)">
        <Icon :size="18" color="#CCC" type="ios-arrow-forward" />
      </Button>
    </div>
     <div  class="scroll-body"   >
    <Menu
      mode="horizontal"
      :theme="theme"
      :active-name="menuName"
       style="float: none;"
       ref="scrollBody"
       :style="{left: tagBodyLeft + 'px'}"
    >
     <!-- 必须用click.native点击事件才能成功 -->

      <MenuItem
        v-for="item in menuList"
        :key="item.name"
        :name="item.name"
        @click.native="handleChange(item)"
        ref="comp"
        style="float: none;"
      >
        <!-- <common-icon :type="item.icon || ''" /> -->
        {{ showTitle(item) }}
      </MenuItem>
    </Menu>
    </div>
  </div>
</template>

<script>
import mixin from '@/components/main/components/side-menu/mixin'
import { mapMutations } from 'vuex'
export default {
  name: 'headerMenu',
  mixins: [mixin],
  data () {
    return {
      theme: 'light',
      tagBodyLeft: 0,
    }
  },
  watch:{
    menuList:{
      handler(val){
        this.$nextTick(() => {
            this.$refs.leftMenu.updateActiveName();
        });
      },
      deep:true
    }
  },
  methods: {
    handleChange (item) {
       //console.log(item.children[0].name,true);
      //   this.$emit('on-change', !this.collapsed)
      this.addMenuName(item.name)

      this.$emit('on-select', item.children[0].name,false)
    },
    ...mapMutations([
      'addMenuName' // 将 `this.addMenuName()` 映射为 `this.$store.commit('addMenuName')`
    ]),
    handleScroll (offset) {
      const outerWidth = this.$refs.scrollOuter.offsetWidth-50
      const bodyWidth = this.$refs.scrollBody.$el.clientWidth
      if (offset > 0) {
        // console.log(1)
        this.tagBodyLeft = Math.min(0, this.tagBodyLeft + offset)
      } else {
        if (outerWidth <= bodyWidth) {
          if (this.tagBodyLeft < -(bodyWidth - outerWidth)) {
            // console.log(2)
            this.tagBodyLeft = this.tagBodyLeft
          } else {
            // console.log(3)
            this.tagBodyLeft = Math.max(this.tagBodyLeft + offset, outerWidth - bodyWidth)
          }
        } else {
          // console.log(4)
          this.tagBodyLeft = 0
        }
      }
    },
  },
  computed: {
    menuList () {
      return this.$store.getters.menuList
    },
    menuName () {
      return this.$store.state.app.menuName
    }
  },

}
</script>

<style lang="less">
@import './header-menu.less';
</style>
